/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AttendanceSelection.vue?vue&type=template&id=fffe0d3e&scoped=true&"
import script from "./AttendanceSelection.vue?vue&type=script&lang=js&"
export * from "./AttendanceSelection.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceSelection.vue?vue&type=style&index=0&id=fffe0d3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffe0d3e",
  null
  
)

export default component.exports